var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _circle2, _rect9, _rect10, _rect11, _defs, _rect12, _circle3, _rect13, _rect14, _rect15, _rect16, _defs2, _rect17, _circle4, _rect18, _rect19, _rect20, _rect21, _defs3, _rect22, _circle5, _rect23, _rect24, _rect25, _rect26, _defs4, _rect27, _circle6, _rect28, _rect29, _rect30, _rect31, _defs5, _rect32, _circle7, _rect33, _rect34, _rect35, _rect36, _defs6, _rect37, _circle8, _rect38, _rect39, _rect40, _rect41;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreen05Shop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 780",
    width: 360,
    height: 780,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 780,
    fill: "#0c1218"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 18,
    width: 34,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 19,
    width: 18,
    height: 8,
    rx: 2,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 19,
    width: 14,
    height: 8,
    rx: 2,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 18,
    width: 20,
    height: 10,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 12,
    width: 100,
    height: 24,
    rx: 12,
    fill: "#000",
    opacity: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 56,
    width: 70,
    height: 7,
    rx: 3.5,
    fill: "#4b5a68",
    opacity: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 72,
    width: 100,
    height: 16,
    rx: 8,
    fill: "#dfe6e8",
    opacity: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 318,
    cy: 70,
    r: 18,
    fill: "#2c7f86",
    opacity: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 318,
    cy: 66,
    r: 7,
    fill: "#5ce1e6",
    opacity: 0.9
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 104,
    width: 320,
    height: 44,
    rx: 22,
    fill: "#141d27",
    opacity: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 122,
    width: 130,
    height: 8,
    rx: 4,
    fill: "#4b5a68",
    opacity: 1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 164,
    width: 154,
    height: 184,
    rx: 16,
    fill: "#141d27",
    opacity: 1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g0",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c7f86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a2531"
  })))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 172,
    width: 138,
    height: 96,
    rx: 10,
    fill: "url(#g0)",
    opacity: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 220,
    r: 20,
    fill: "#5ce1e6",
    opacity: 0.35
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 280,
    width: 110,
    height: 8,
    rx: 4,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 296,
    width: 70,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 314,
    width: 130,
    height: 24,
    rx: 12,
    fill: "#1a2531",
    opacity: 1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 164,
    width: 154,
    height: 184,
    rx: 16,
    fill: "#141d27",
    opacity: 1
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c7f86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a2531"
  })))), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 172,
    width: 138,
    height: 96,
    rx: 10,
    fill: "url(#g1)",
    opacity: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 220,
    r: 20,
    fill: "#5ce1e6",
    opacity: 0.35
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 280,
    width: 110,
    height: 8,
    rx: 4,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 296,
    width: 70,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 314,
    width: 130,
    height: 24,
    rx: 12,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 360,
    width: 154,
    height: 184,
    rx: 16,
    fill: "#141d27",
    opacity: 1
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c7f86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a2531"
  })))), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 368,
    width: 138,
    height: 96,
    rx: 10,
    fill: "url(#g2)",
    opacity: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 416,
    r: 20,
    fill: "#5ce1e6",
    opacity: 0.35
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 476,
    width: 110,
    height: 8,
    rx: 4,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 492,
    width: 70,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 510,
    width: 130,
    height: 24,
    rx: 12,
    fill: "#1a2531",
    opacity: 1
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 360,
    width: 154,
    height: 184,
    rx: 16,
    fill: "#141d27",
    opacity: 1
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c7f86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a2531"
  })))), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 368,
    width: 138,
    height: 96,
    rx: 10,
    fill: "url(#g3)",
    opacity: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 416,
    r: 20,
    fill: "#5ce1e6",
    opacity: 0.35
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 476,
    width: 110,
    height: 8,
    rx: 4,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 492,
    width: 70,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 510,
    width: 130,
    height: 24,
    rx: 12,
    fill: "#1a2531",
    opacity: 1
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 556,
    width: 154,
    height: 184,
    rx: 16,
    fill: "#141d27",
    opacity: 1
  })), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c7f86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a2531"
  })))), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 564,
    width: 138,
    height: 96,
    rx: 10,
    fill: "url(#g4)",
    opacity: 1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 612,
    r: 20,
    fill: "#5ce1e6",
    opacity: 0.35
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 672,
    width: 110,
    height: 8,
    rx: 4,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 688,
    width: 70,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 706,
    width: 130,
    height: 24,
    rx: 12,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 556,
    width: 154,
    height: 184,
    rx: 16,
    fill: "#141d27",
    opacity: 1
  })), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g5",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c7f86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a2531"
  })))), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 564,
    width: 138,
    height: 96,
    rx: 10,
    fill: "url(#g5)",
    opacity: 1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 612,
    r: 20,
    fill: "#5ce1e6",
    opacity: 0.35
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 672,
    width: 110,
    height: 8,
    rx: 4,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 688,
    width: 70,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 706,
    width: 130,
    height: 24,
    rx: 12,
    fill: "#1a2531",
    opacity: 1
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 766,
    width: 120,
    height: 5,
    rx: 2.5,
    fill: "#dfe6e8",
    opacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen05Shop);
export default __webpack_public_path__ + "static/media/screen-05-shop.7632da1f5a7298492aaa792257a64627.svg";
export { ForwardRef as ReactComponent };